import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MFACodeInput',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const mfaCode = computed({
    get () {
        return props.modelValue
    },
    set (value) {
        emit('update:modelValue', value)
    }
})

async function mfaCodeInput(event: KeyboardEvent) {
    if (/^[a-zA-Z]$/i.test(event.key) && !event.ctrlKey) {
        event.preventDefault();
        return;
    }

    if (/^[0-9]$/i.test(event.key) && mfaCode.value.length >= 6) {
        event.preventDefault();
        return;
    }
}


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    class: "form-control",
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mfaCode).value = $event)),
    placeholder: "Code",
    onKeydown: mfaCodeInput,
    ref: "verifyCodeRef",
    autocomplete: "off",
    maxlength: 6
  }, null, 544)), [
    [_vModelText, mfaCode.value]
  ])
}
}

})